// extracted by mini-css-extract-plugin
module.exports = {"error":"ErrorMessage__error___2tRjL"};